import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GetAllActiveStudiesResponse, GetClinTrakStudyDataResponse, GetPendingSitesResponse } from '@app/generated-api';
import { getSiteBaseUrl } from '@utility/utility';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ClinTrakDataService2 {
    private httpClient = inject(HttpClient);
    getAllActiveStudies(): Observable<GetAllActiveStudiesResponse[]> {
        return this.httpClient.get<GetAllActiveStudiesResponse[]>(
            `${getSiteBaseUrl()}/api/v2/clintrak/studies/activestudies`
        );
    }

    getPendingSites(studyId: number): Observable<GetPendingSitesResponse[]> {
        return this.httpClient.get<GetPendingSitesResponse[]>(
            `${getSiteBaseUrl()}/api/v2/clintrak/studies/${studyId}/sites`
        );
    }

    getClinTrakStudyData(studyId: string): Observable<GetClinTrakStudyDataResponse> {
        return this.httpClient.get<GetClinTrakStudyDataResponse>(
            `${getSiteBaseUrl()}/api/v2/clintrak/studies/data/${studyId}`
        );
    }
}
